import React, { Component, cloneElement } from "react";
import { createPortal } from "react-dom";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import "./style.css";

export class ToolTip extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.contentContainer = document.createElement("div");
  }

  state = {
    comp: null,
    instance: null,
  };

  componentDidMount = () => {
    let node = this.myRef.current;
    let instance = tippy(node, {
      ...this.props.config,
      content: this.contentContainer,
    });
    this.setState({ instance: instance });
  };

  componentWillUnmount = () => {
    if (this.state.instance) this.state.instance.destroy();
  };

  componentDidUpdate = () => {
    if (this.state.instance === null) {
      return;
    }

    if (this.state.instance.props.trigger === "manual") {
      if (this.props.show) {
        this.state.instance.show();
      } else {
        this.state.instance.hide();
      }
    }

    if (this.props.disabled) {
      this.state.instance.disable();
    } else {
      this.state.instance.enable();
    }

    try {
      this.props.className.split(" ").forEach((c) => {
        this.state.instance.popper.classList.add(c);
      });
    } catch (e) {}

    this.state.instance.setProps({
      ...this.props.config,
      content: this.contentContainer,
    });
  };

  show = () => {};

  render() {
    let children = this.props.children;
    return (
      <>
        {cloneElement(children, {
          ref: this.myRef,
        })}
        {createPortal(this.props.content, this.contentContainer)}
      </>
    );
  }
}

ToolTip.defaultProps = {
  show: false,
  disabled: false,
  className: "tippy-class",
};

export default ToolTip;
